<template>
  <v-row class="my-4">
    <v-col
      v-for="escala in escalas"
      :key="escala.descricao"
    >
      <template>
        <div
          align="center"
          class="d-flex flex-column"
        >
          <v-rating
            v-model="escala.rating"
            :length="5"
            readonly
            background-color="grey"
            color="secondary lighten-3"
            size="20"
          />
          <span class="font-weight-bold">{{ escala.descricao }}</span>
        </div>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'LegendaEscalaAvaliacao',

  props: {
    escalas: {
      type: Array,
      required: true,
    },
  },
};
</script>
